import(/* webpackMode: "eager" */ "/vercel/path0/apps/client/src/app/global-error.tsx");
